export const NAME = 'create-template-modal';
